export default __webpack_public_path__ + "26c3c8adcd2dc8d9467347f885cba3ba.svg";